/**
 * COURE.HUB.DS.TransactionLog.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ProcessStateEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export const ProcessStateEnum = {
    NUMBER_1: 1 as ProcessStateEnum,
    NUMBER_2: 2 as ProcessStateEnum,
    NUMBER_3: 3 as ProcessStateEnum,
    NUMBER_4: 4 as ProcessStateEnum,
    NUMBER_5: 5 as ProcessStateEnum,
    NUMBER_6: 6 as ProcessStateEnum,
    NUMBER_7: 7 as ProcessStateEnum,
    NUMBER_8: 8 as ProcessStateEnum
};